import request from '@/utils/request'

// ==================== 车辆保障信息管理 ====================

// 分页查询车辆保障信息
export function getVehicleGuaranteeList(params) {
  return request({
    url: '/api/admin/guarantee/vehicle/list',
    method: 'get',
    params
  })
}

// 添加车辆保障信息
export function addVehicleGuarantee(data) {
  return request({
    url: '/api/admin/guarantee/vehicle/add',
    method: 'post',
    data
  })
}

// 更新车辆保障信息
export function updateVehicleGuarantee(data) {
  return request({
    url: '/api/admin/guarantee/vehicle/update',
    method: 'post',
    data
  })
}

// 删除车辆保障信息
export function deleteVehicleGuarantee(id) {
  return request({
    url: '/api/admin/guarantee/vehicle/delete',
    method: 'post',
    params: { id }
  })
}

// ==================== 保障说明内容管理 ====================

// 分页查询保障说明内容
export function getGuaranteeContentList(params) {
  return request({
    url: '/api/admin/guarantee/content/list',
    method: 'get',
    params
  })
}

// 添加保障说明内容
export function addGuaranteeContent(data) {
  return request({
    url: '/api/admin/guarantee/content/add',
    method: 'post',
    data
  })
}

// 更新保障说明内容
export function updateGuaranteeContent(data) {
  return request({
    url: '/api/admin/guarantee/content/update',
    method: 'post',
    data
  })
}

// 删除保障说明内容
export function deleteGuaranteeContent(id) {
  return request({
    url: '/api/admin/guarantee/content/delete',
    method: 'post',
    params: { id }
  })
}

// ==================== 理赔流程管理 ====================

// 查询所有理赔流程
export function getClaimsProcessList() {
  return request({
    url: '/api/admin/guarantee/process/list',
    method: 'get'
  })
}

// 添加理赔流程
export function addClaimsProcess(data) {
  return request({
    url: '/api/admin/guarantee/process/add',
    method: 'post',
    data
  })
}

// 更新理赔流程
export function updateClaimsProcess(data) {
  return request({
    url: '/api/admin/guarantee/process/update',
    method: 'post',
    data
  })
}

// 删除理赔流程
export function deleteClaimsProcess(id) {
  return request({
    url: '/api/admin/guarantee/process/delete',
    method: 'post',
    params: { id }
  })
} 